module.exports = __webpack_public_path__ + "r-v3/img/circle.11416542.svg";